import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import theme from '../../assets/theme';

const TitleCard = ({ reservationId, checkIn, checkOut, status }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor="primary.main"
            color="common.white"
            p={2}
            borderRadius={1}
        >
            {/* Left: Reservation ID */}
            <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="buttonL">Reservation ID</Typography>
                <Typography variant="headingLarge">{reservationId}</Typography>
            </Box>

            {/* Center: Check-in and Check-out */}
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexGrow={1}
                gap={2}
            >
                <Box>
                    <Typography variant="buttonL">Check-in:</Typography>
                    <Typography variant="headingLarge" ml={2}>{checkIn}</Typography>
                </Box>

                <Typography variant="headingLarge">|</Typography>

                <Box>
                    <Typography variant="buttonL">Check-out:</Typography>
                    <Typography variant="headingLarge" ml={2}>{checkOut}</Typography>
                </Box>
            </Box>

            {/* Right: Status */}
            {
                status && <Chip
                    label={status}
                    sx={{
                        backgroundColor: 'orange.main',
                        color: 'primary.main',
                        borderRadius: "4px",
                        height: 27,
                        fontWeight: 'bold',
                        borderRadius: "4px",
                        ml: 2
                    }}
                />
            }


        </Box>
    );
};

export default TitleCard;
